import PropTypes from 'prop-types';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const createUnstyledPluginButton = ({
  text
}) => {
  const UnstyledTextButton = ({
    onClick
  }) => {
    return /*#__PURE__*/_jsx(Button, {
      onClick: onClick,
      children: text
    });
  };
  UnstyledTextButton.propTypes = {
    onClick: PropTypes.func
  };
  return UnstyledTextButton;
};
export default createUnstyledPluginButton;